import "../styles/dealcard.css";

function DealCard({ deal, onSelect, onConfirm, onViewDetails, isActive, isSelected }) {
  const getScoreColor = (score) => {
    if (score >= 80) return '#1d4ed8';
    if (score >= 60) return '#1d4ed8';
    if (score >= 40) return '#1d4ed8';
    return '#0f2d5e';
  };

  const getScoreLabel = (score) => {
    if (score >= 80) return 'Strong Buy';
    if (score >= 60) return 'Buy';
    if (score >= 40) return 'Review';
    return 'Pass';
  };

  const getScoreClass = (score) => {
    if (score >= 80) return 'strong-buy';
    if (score >= 60) return 'buy';
    if (score >= 40) return 'review';
    return 'pass';
  };

  const getSourceIcon = (source) => {
    switch (source) {
      case 'loopnet_live': return '🟢';
      case 'broker_email': return '📧';
      case 'listings': return '🏢';
      case 'manual_upload': return '📤';
      default: return '📋';
    }
  };

  return (
    <div 
      className={`deal-card ${isActive ? 'active' : ''} ${isSelected && !isActive ? 'selected' : ''}`}
      onClick={() => onSelect(deal)}
    >
      <div className="deal-header">
        <div className="deal-title-section">
          <h3 className="deal-name">{deal.name}</h3>
          <div className="deal-source">
            <span className="source-icon">{getSourceIcon(deal.source)}</span>
            <span className="source-text">{deal.source ? deal.source.replace(/_/g, ' ') : 'Unknown'}</span>
            {deal.source === 'loopnet_live' && <span className="live-source-pill">LIVE</span>}
          </div>
        </div>
        <div className="deal-score">
          <div className="score-number" style={{ color: getScoreColor(deal.score) }}>{deal.score}/100</div>
          <div className={`score-label ${getScoreClass(deal.score)}`}>{getScoreLabel(deal.score)}</div>
        </div>
      </div>

      <div className="deal-location">
        <span className="location-icon">📍</span>
        <span>{deal.location}, {deal.city}, {deal.state}</span>
      </div>

      <div className="deal-metrics">
        <div className="metric">
          <span className="metric-label">Price</span>
          <span className="metric-value">{typeof deal.price === 'number' ? `$${deal.price.toLocaleString()}` : deal.price || 'N/A'}</span>
        </div>
        <div className="metric">
          <span className="metric-label">Units</span>
          <span className="metric-value">{deal.units}</span>
        </div>
        <div className="metric">
          <span className="metric-label">Building</span>
          <span className="metric-value">{deal.buildingType}</span>
        </div>
      </div>

      <div className="deal-details">
        <div className="detail-row">
          <span className="detail-label">Year Built:</span>
          <span className="detail-value">{deal.yearBuilt}</span>
        </div>
        <div className="detail-row">
          <span className="detail-label">Square Feet:</span>
          <span className="detail-value">{deal.squareFeet ? deal.squareFeet.toLocaleString() : 'N/A'}</span>
        </div>
        <div className="detail-row">
          <span className="detail-label">Cap Rate:</span>
          <span className="detail-value">{deal.capRate ? `${deal.capRate}%` : 'N/A'}</span>
        </div>
        {deal.daysOnMarket && (
          <div className="detail-row">
            <span className="detail-label">Days on Market:</span>
            <span className="detail-value">{deal.daysOnMarket}</span>
          </div>
        )}
      </div>

      {(isActive || isSelected) && (
        <div className="active-indicator">
          <span className="active-text">{isActive ? '✓ Active Deal' : 'Selected'}</span>
        </div>
      )}

      <div className="deal-actions">
        <button
          className="select-button"
          onClick={(event) => {
            event.stopPropagation();
            if (isActive) {
              if (onViewDetails) onViewDetails(deal);
            } else if (isSelected && !isActive && onConfirm) {
              onConfirm();
            } else {
              onSelect(deal);
            }
          }}
        >
          {isActive ? '🔍 View Details' : isSelected ? 'Confirm Deal Selection' : 'Select Deal'}
        </button>
      </div>
    </div>
  );
}

export default DealCard;
